export default __webpack_public_path__ + "static/logo-4e4077df00a37b1c2e97edfcfdbd2e8c.svg";